import type { MapRef } from 'react-map-gl/mapbox';
import { CUSTOM_LAYER_IDS } from '../BasemapPicker';

/**
 * Source ids for layers that currently have rendered content (features in view + visible raster
 * layers). Same logic as the main map `Legend` widget.
 */
export function getCurrentlyVisibleLegendLayerIds(map: MapRef | null | undefined): string[] {
  if (!map) {
    return [];
  }
  const mapbox = map.getMap();
  if (map.isMoving() || !mapbox.isStyleLoaded()) {
    return [];
  }

  const layersInView = map.queryRenderedFeatures();
  const uniqueSourceIds = [...new Set(layersInView.map((f) => f.properties?.cgSourceId))].filter(
    (id): id is string => id !== undefined,
  );

  const style = map.getStyle();
  const rasterLayerIds =
    style?.layers
      ?.filter((l) => l.type === 'raster' && l.id !== 'satellite' && !CUSTOM_LAYER_IDS.includes(l.id))
      .map((l) => l.id) ?? [];

  return [...uniqueSourceIds, ...rasterLayerIds];
}
